// this is a hacky way to handle redirection for Connect+ via UI logic as handling it via module details table is not 
// straight forward and will require changes, it will be picked up as a tech debt
// We are dettaching old connect plus from glue and adding it to cc-stack, with that this will be handled dynamically and 
// hard coding won't be required.
const NIGHTLY = 'crm-nightly-new.cc.capillarytech.com';
const NIGHTLY_INTOUCH = 'nightly.intouch.capillarytech.com';
const EUCRM = 'eucrm.cc.capillarytech.com';
const EUCRM_INTOUCH = 'eu.intouch.capillarytech.com'
const USCRM = 'uscrm.cc.capillarytech.com';
const INCRM = 'incrm.cc.capillarytech.com';
const APAC = 'apac.intouch.capillarytech.com';
const NORTH_AMERICA = 'north-america.intouch.capillarytech.com';
const SGCRM = 'sgcrm.cc.capillarytech.com';
const APAC2 = 'apac2.intouch.capillarytech.com';
const TATACRM = 'tatacrm.cc.capillarytech.com';
const TATACRM_INTOUCH = 'tata.intouch.capillarytech.com';
const USHCCRM = 'ushccrm.cc.capillarytech.com';
const USHCCRM_INTOUCH = 'ushc.intouch.capillarytech.com';
const NIGHTLY_CONNECT_PLUS_URL =
  'https://crm-nightly-new.connectplus.capillarytech.com';
const PROD_CONNECT_PLUS_URL =
  'https://eucrm.connectplus.capillarytech.com';
const US_PROD_CONNECT_PLUS_URL = 'https://uscrm.connectplus.capillarytech.com';
const EU_PROD_CONNECT_PLUS_URL = 'https://eucrm.connectplus.capillarytech.com';
const IN_PROD_CONNECT_PLUS_URL = 'https://incrm.connectplus.capillarytech.com';
const SG_PROD_CONNECT_PLUS_URL = 'https://sgcrm.connectplus.capillarytech.com';
const TATA_PROD_CONNECT_PLUS_URL = 'https://tatacrm.connectplus.capillarytech.com';
const USHC_PROD_CONNECT_PLUS_URL = 'https://ushccrm.connectplus.capillarytech.com';

export const handleConnectPlusRedirection = ({ product, cluster }) => {
  const currentHost = window.location.host;
  switch (currentHost) {
    case NIGHTLY:
    case NIGHTLY_INTOUCH:
      window.open(`${NIGHTLY_CONNECT_PLUS_URL}/${product.url}`, '_blank');
      break;
    case EUCRM:
    case EUCRM_INTOUCH:
      window.open(`${EU_PROD_CONNECT_PLUS_URL}/${product.url}`, '_blank');
      break;
    case USCRM:
    case NORTH_AMERICA:
      window.open(`${US_PROD_CONNECT_PLUS_URL}/${product.url}`, '_blank');
      break;
    case INCRM:
    case APAC:
      window.open(`${IN_PROD_CONNECT_PLUS_URL}/${product.url}`, '_blank');
      break;
    case SGCRM:
    case APAC2:
      window.open(`${SG_PROD_CONNECT_PLUS_URL}/${product.url}`, '_blank');
      break;
    case TATACRM:
    case TATACRM_INTOUCH:
      window.open(`${TATA_PROD_CONNECT_PLUS_URL}/${product.url}`, '_blank');
      break;
    case USHCCRM:
    case USHCCRM_INTOUCH:
      window.open(`${USHC_PROD_CONNECT_PLUS_URL}/${product.url}`, '_blank');
      break;
    default:
      window.open(`${PROD_CONNECT_PLUS_URL}/${product.url}`, '_blank');
      break;
  }
};
